


class LSGIngredientTabs extends HTMLElement {
    constructor() {
        super();

        this.debug  = true;
    }

    connectedCallback() {
        if (this.debug) console.log(`[LSG] Ingredient Tabs connected.`);

        const tabEls    = this.querySelectorAll(`[lsg-ingredient-tab]`);
        
        tabEls.forEach((tabEl) => {
            tabEl.addEventListener(`click`, (e) => {
                const clickedEl = e.target,
                      handle    = clickedEl.getAttribute(`lsg-ingredient-tab`);
            
                this.updateSelection(handle);
            });
        });

        const selectEls = this.querySelectorAll(`[lsg-ingredient-select-btn]`);
        
        selectEls.forEach((selectEl) => {
            selectEl.addEventListener(`click`, (e) => {
                const menuEl = this.querySelector(`[lsg-ingredient-menu]`);
            
                menuEl.classList.add(`lsg-menu-open`);
            });
        });

        const menuBtnEls = this.querySelectorAll(`[lsg-ingredient-menu-btn]`);
        
        menuBtnEls.forEach((menuBtnEl) => {
            menuBtnEl.addEventListener(`click`, (e) => {
                const clickedEl = e.target,
                      handle    = clickedEl.getAttribute(`lsg-ingredient-menu-btn`);
            
                this.updateSelection(handle);
            });
        });

        document.addEventListener(`buyboxSwitched`, (e) => {
            if (this.debug) console.log(`[LSG] buyboxSwitched event, e:`, e);
            
            this.updateSelection(e.detail.productHandle);
        });
    }

    updateSelection(handle) {
        const tabEls        = this.querySelectorAll(`[lsg-ingredient-tab]`),
              cardEls       = this.querySelectorAll(`[lsg-ingredient-card]`),
              selectEls     = this.querySelectorAll(`[lsg-ingredient-select-btn]`),
              menuBtnEls    = this.querySelectorAll(`[lsg-ingredient-menu-btn]`);
            
        tabEls.forEach((tabEl) => {
            tabEl.classList.remove(`lsg-tab-active`);
        });
        
        cardEls.forEach((cardEl) => {
            cardEl.classList.remove(`lsg-card-active`);
        });
        
        selectEls.forEach((selectEl) => {
            selectEl.classList.remove(`lsg-select-active`);
        });
        
        menuBtnEls.forEach((menuBtnEl) => {
            menuBtnEl.classList.remove(`lsg-menu-btn-active`);
        });

        const menuEl = this.querySelector(`[lsg-ingredient-menu]`);
    
        menuEl.classList.remove(`lsg-menu-open`);

        const newCardEl = this.querySelector(`[lsg-ingredient-card="${handle}"]`);
        newCardEl.classList.add(`lsg-card-active`);

        const newTabEl = this.querySelector(`[lsg-ingredient-tab="${handle}"]`);
        newTabEl.classList.add(`lsg-tab-active`);

        const newSelectEl = this.querySelector(`[lsg-ingredient-select-btn="${handle}"]`);
        newSelectEl.classList.add(`lsg-select-active`);

        const newMenuBtnEl = this.querySelector(`[lsg-ingredient-menu-btn="${handle}"]`);
        newMenuBtnEl.classList.add(`lsg-menu-btn-active`);

        newMenuBtnEl.parentElement.insertBefore(newMenuBtnEl, newMenuBtnEl.parentElement.firstChild);
    }
}

customElements.define(`lsg-ingredient-tabs`, LSGIngredientTabs);